import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { parseMessages } from 'helpers/parse-dll-error'
import { prepareData } from 'helpers/prepare-req-data'
import client from 'api'
import _ from 'lodash'

const gridFiltersConfig: any = {
    LEISTUNGSZEITRAUMVON: { prop: null, param: 'LEISTUNGSZEITRAUMVON' },
    LEISTUNGSZEITRAUMBIS: { prop: null, param: 'LEISTUNGSZEITRAUMBIS' },
}

const initialState = {
    loadXspgetzlgtlrzListStatus: 'idle',
    loadXspgetzlgtlrzListError: undefined as any,
    loadXspgetzlgtlrzListLastParams: undefined,
    createXspgetzlgtlrzStatus: 'idle',
    createXspgetzlgtlrzError: undefined as any,
    updateXspgetzlgtlrzStatus: 'idle',
    updateXspgetzlgtlrzError: undefined as any,
    deleteXspgetzlgtlrzStatus: 'idle',
    deleteXspgetzlgtlrzError: undefined as any,

    xspgetzlgtlrzList: [] as any[],
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any
}

export const loadXspgetzlgtlrzList = createAsyncThunk('xspgetzlgtlrzSlice/loadXspgetzlgtlrzList', async ({ gridFilters, forceReload=false }: any, { rejectWithValue, getState }: any) => {
    const { loadXspgetzlgtlrzListLastParams } = getState().xspgetzlgtlrzSlice
    const params: any = {}
    for(const f in gridFiltersConfig) {
        const { prop, param } = gridFiltersConfig[f]
        if (prop && gridFilters.lookupValues[f]) {  // we need a property from the lookup object
            params[`MIN_${ param }`] = gridFilters.lookupValues[f][prop]
            params[`MAX_${ param }`] = gridFilters.lookupValues[f][prop]
        } else if (!prop && gridFilters.values[f]) {
            params[`MIN_${ param }`] = gridFilters.values[f]
            params[`MAX_${ param }`] = gridFilters.values[f]
        }
    }

    const url = `/api/ixweb/xspgetzlgtlrz/`
    let _allParams: any = new URLSearchParams(url.split('?')[1])
    Object.entries(params).forEach(([key, value]) => _allParams.append(key, value as any))
    _allParams.sort()
    _allParams = _allParams.toString()

    if (_allParams === loadXspgetzlgtlrzListLastParams && !forceReload) {
        return
    }

    const res = await client.get(url, { params })

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return { data: res.data.data, params: _allParams }
        }
    } else {  // backend response
        return { data: res.data, params: _allParams }
    }
})
export const createXspgetzlgtlrz = createAsyncThunk('xspgetzlgtlrzSlice/createXspgetzlgtlrz', async (xspgetzlgtlrz: any, { rejectWithValue }: any) => {

    const url = `/api/ixweb/xspgetzlgtlrz/`

    const res = await client.post(url, prepareData(xspgetzlgtlrz))

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return { ...xspgetzlgtlrz, HDR_ID: res.data.data.id }
        }
    } else {  // backend response
        return res.data
    }
})
export const updateXspgetzlgtlrz = createAsyncThunk('xspgetzlgtlrzSlice/updateXspgetzlgtlrz', async (xspgetzlgtlrz: any, { rejectWithValue }: any) => {

    const url = `/api/ixweb/xspgetzlgtlrz/${xspgetzlgtlrz.HDR_ID}/`

    const res = await client.put(url, prepareData(xspgetzlgtlrz))

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return xspgetzlgtlrz
        }
    } else {  // backend response
        return res.data
    }
})
export const deleteXspgetzlgtlrz = createAsyncThunk('xspgetzlgtlrzSlice/deleteXspgetzlgtlrz', async (id: any, { rejectWithValue }: any) => {

    const url = `/api/ixweb/xspgetzlgtlrz/${id}/`

    const res = await client.delete(url)

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return id
        }
    } else {  // backend response
        return id
    }
})

const XspgetzlgtlrzSlice = createSlice({
    name: 'xspgetzlgtlrzSlice',
    initialState,
    reducers: {
        resetloadXspgetzlgtlrzListError: (state) => {
            state.loadXspgetzlgtlrzListError = undefined
        },
        resetcreateXspgetzlgtlrzError: (state) => {
            state.createXspgetzlgtlrzError = undefined
        },
        resetupdateXspgetzlgtlrzError: (state) => {
            state.updateXspgetzlgtlrzError = undefined
        },
        resetdeleteXspgetzlgtlrzError: (state) => {
            state.deleteXspgetzlgtlrzError = undefined
        },
        removeFromXspgetzlgtlrzListById: (state, action) => {
            state.xspgetzlgtlrzList = state.xspgetzlgtlrzList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
    },
    extraReducers: builder => {
        builder.addCase(loadXspgetzlgtlrzList.pending, (state) => {
            state.loadXspgetzlgtlrzListStatus = 'pending'
            state.loadXspgetzlgtlrzListError = undefined
        })
        builder.addCase(loadXspgetzlgtlrzList.fulfilled, (state, action) => {
            state.loadXspgetzlgtlrzListStatus = 'idle'

            if (!action.payload) { return }

            state.loadXspgetzlgtlrzListLastParams = action.payload.params

            state.xspgetzlgtlrzList = action.payload.data
        })
        builder.addCase(loadXspgetzlgtlrzList.rejected, (state, action) => {
            state.loadXspgetzlgtlrzListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadXspgetzlgtlrzListError = action.error.message
            } else {
                state.loadXspgetzlgtlrzListError = action.payload
            }
        })

        builder.addCase(createXspgetzlgtlrz.pending, (state) => {
            state.createXspgetzlgtlrzStatus = 'pending'
            state.createXspgetzlgtlrzError = undefined
        })
        builder.addCase(createXspgetzlgtlrz.fulfilled, (state, action) => {
            state.createXspgetzlgtlrzStatus = 'idle'


            state.xspgetzlgtlrzList = [...state.xspgetzlgtlrzList, action.payload]
        })
        builder.addCase(createXspgetzlgtlrz.rejected, (state, action) => {
            state.createXspgetzlgtlrzStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.createXspgetzlgtlrzError = action.error.message
            } else {
                state.createXspgetzlgtlrzError = action.payload
            }
        })

        builder.addCase(updateXspgetzlgtlrz.pending, (state) => {
            state.updateXspgetzlgtlrzStatus = 'pending'
            state.updateXspgetzlgtlrzError = undefined
        })
        builder.addCase(updateXspgetzlgtlrz.fulfilled, (state, action) => {
            state.updateXspgetzlgtlrzStatus = 'idle'


            const i = state.xspgetzlgtlrzList.findIndex((x: any) => x.HDR_ID === action.payload.HDR_ID)
            if (i === -1) { state.xspgetzlgtlrzList.push(action.payload) }
            else { state.xspgetzlgtlrzList[i] = { ...state.xspgetzlgtlrzList[i], ...action.payload } }
        })
        builder.addCase(updateXspgetzlgtlrz.rejected, (state, action) => {
            state.updateXspgetzlgtlrzStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.updateXspgetzlgtlrzError = action.error.message
            } else {
                state.updateXspgetzlgtlrzError = action.payload
            }
        })

        builder.addCase(deleteXspgetzlgtlrz.pending, (state) => {
            state.deleteXspgetzlgtlrzStatus = 'pending'
            state.deleteXspgetzlgtlrzError = undefined
        })
        builder.addCase(deleteXspgetzlgtlrz.fulfilled, (state, action) => {
            state.deleteXspgetzlgtlrzStatus = 'idle'


            state.xspgetzlgtlrzList = state.xspgetzlgtlrzList.filter((x: any) => x.HDR_ID !== action.payload)
        })
        builder.addCase(deleteXspgetzlgtlrz.rejected, (state, action) => {
            state.deleteXspgetzlgtlrzStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteXspgetzlgtlrzError = action.error.message
            } else {
                state.deleteXspgetzlgtlrzError = action.payload
            }
        })

    }
})

export const {
    resetloadXspgetzlgtlrzListError,
    resetcreateXspgetzlgtlrzError,
    resetupdateXspgetzlgtlrzError,
    resetdeleteXspgetzlgtlrzError,
    removeFromXspgetzlgtlrzListById,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef
} = XspgetzlgtlrzSlice.actions
export default XspgetzlgtlrzSlice.reducer
